module.exports = __webpack_public_path__ + "img/page.268a859f.png";